module.exports = __webpack_public_path__ + "b66f027bd96e925aca813a7ade07e6a2.png";